import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supervisores-tabla',
  templateUrl: './supervisores-tabla.component.html',
  styleUrls: ['./supervisores-tabla.component.scss']
})
export class SupervisoresTablaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
